module.exports = __webpack_public_path__ + "img/hands.94aa4fca.svg";